import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { AuthService } from '../../../../services/auth/auth.service';

@Component({
  selector: 'app-password-reset',
  standalone: true,
  imports: [FormsModule, CommonModule],
  templateUrl: './password-reset.component.html',
  styleUrl: './password-reset.component.css'
})
export class PasswordResetComponent {
  step: 'username' | 'code' = 'username'; // Tracks the current step
  username: string = '';
  email: string = '';
  verificationCode: string = '';
  newPassword: string = '';
  errorMessage: string = '';
  passwordFieldType: string = 'password';
  isPwdSuccessfullyReset: boolean = false;
  showTooltip: boolean = false;

  passwordValidations = {
    minLength: false,
    number: false,
    lowercase: false,
    uppercase: false,
    specialChar: false,
  };

  @Output() emitterResetPasswordOpen = new EventEmitter<boolean>();

  constructor (private authService: AuthService) { }

  togglePasswordVisibility (): void {
    this.passwordFieldType = this.passwordFieldType === 'password' ? 'text' : 'password';
  }

  goBack () {
    this.step = 'username';
  }

  backToLogin () {
    this.emitterResetPasswordOpen.emit(false);
  }

  // Step 1: Request a password reset
  requestPasswordReset () {
    // we use this for now just to do it visually
    /* if(this.username=="RAM1"){
       this.errorMessage="";
       this.step = 'code';
     }else{
       this.errorMessage = 'Il nome utente è obbligatorio';
       return;
     }*/
    this.errorMessage = '';
    if (!this.username) {
      this.errorMessage = 'Il nome utente è obbligatorio';
      return;
    }

    console.log('email', this.username);

    this.authService.initiatePasswordReset(this.username).subscribe({
      next: (response) => {
        this.email = response.destination;
        this.step = 'code'; // Move to the next step
      },
      error: (err: any) => {
        this.errorMessage = err.message || 'An error occurred while requesting the password reset';
      }
    });
  }

  // Step 2: Confirm password reset
  confirmPasswordReset () {
    // we use this for now just to do it visually
    this.errorMessage = '';
    if (!this.verificationCode || !this.newPassword) {
      this.errorMessage = 'Tutti i campi devono essere compilati';
      return;
    } /*else if (this.verificationCode == "123" && this.newPassword) {
      this.isPwdSuccessfullyReset = true;
    }*/

    this.validatePassword();

    const validations = Object.values(this.passwordValidations);
    const isPasswordValid = validations.every(v => v);

    if (!isPasswordValid) {
      // Optional: show feedback to user
      this.errorMessage = "La password non soddisfa tutti i requisiti.";
      return;
    }

    this.authService.confirmPasswordReset(this.username, this.verificationCode, this.newPassword).subscribe({
      next: () => {
        this.verificationCode = '';
        this.newPassword = '';
        this.isPwdSuccessfullyReset = true;
        //alert('Password successfully reset!');
      },
      error: (err: any) => {
        this.errorMessage = err.message || 'An error occurred while confirming the password reset';
      }
    });


  }

  validatePassword (): void {
    const pw = this.newPassword || '';
    this.passwordValidations = {
      minLength: pw.length >= 8,
      number: /\d/.test(pw),
      lowercase: /[a-z]/.test(pw),
      uppercase: /[A-Z]/.test(pw),
      specialChar: /[!@#$%^&*()\[\]{}\-_+=~`'"“”‘’.,:;?<>\\|]/.test(pw) || /\s/.test(pw),
    };
  }

}
